import { render, staticRenderFns } from "./RedirectionFromOnboarding.vue?vue&type=template&id=2ae30bfc&"
import script from "./RedirectionFromOnboarding.vue?vue&type=script&lang=js&"
export * from "./RedirectionFromOnboarding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports